import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Study } from 'src/types/studies';

interface OrganizationStudiesTableProps {
  studies: Study[];
}

export function OrganizationStudiesTable({ studies }: OrganizationStudiesTableProps) {
  const { t } = useTranslation();

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell>{t('name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('display_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('created_header')}</DataTable.HeaderCell>
      </DataTable.Header>

      <DataTable.Body className="h-96 overflow-auto">
        {studies.length > 0 ? (
          studies.map((study: Study) => (
            <DataTable.Row key={study.studyId}>
              <DataTable.RowCell>{study.name}</DataTable.RowCell>
              <DataTable.RowCell>{study.displayName}</DataTable.RowCell>
              <DataTable.RowCell>{dayjs(study.createdAt).format('YYYY-MM-DD')}</DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow text-white items-center justify-center p-4">
            {t('no_studies_created')}
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
